// suffix of doc link, see utils/feature-flags.js how to get complete doc link
export const DOC = {
  CONSOLE_URL:                `/host/#remote-console`,
  RANCHER_INTEGRATION_URL:    `/rancher/rancher-integration`,
  KSMTUNED_MODE:              `/host/#ksmtuned-mode`,
  UPGRADE_URL:                `/upgrade/index`,
  UPGRADE_CONFIG_URL:         `/advanced/index#upgrade-config`,
  STORAGE_NETWORK_EXAMPLE:    `/advanced/storagenetwork#configuration-example`,
  SUPPORT_BUNDLE_NAMESPACES:  `/advanced/index/#support-bundle-namespaces`,
  VPC_CONFIGURATION_EXAMPLES: `/networking/kubeovn-vpc#vpc-peering-configuration-examples`,
  NETWORK_POLICY:             `/networking/kubeovn-vm-isolation/#network-policies`,
  TRANSPARENT_HUGEPAGES:      `https://docs.kernel.org/admin-guide/mm/transhuge.html`,
};
